import type { NavItem } from '../types/content';

export const mainNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Our Consultants', to: '/consultants', feature: 'consultants' },
  { label: 'Our Expertise', to: '/expertise' },
  { label: 'Industries', to: '/industries' },
  { label: 'For Employers', to: '/employers' },
  { label: 'For Candidates', to: '/candidates' },
  { label: 'Leadership Opportunities', to: '/opportunities' },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact Us', to: '/contact' },
];

export const footerFirmNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Our Consultants', to: '/consultants', feature: 'consultants' },
  { label: 'Our Expertise', to: '/expertise' },
  { label: 'Industries', to: '/industries' },
  { label: 'Insights', to: '/insights' },
];

export const footerEngageNav: NavItem[] = [
  { label: 'For Employers', to: '/employers' },
  { label: 'For Candidates', to: '/candidates' },
  { label: 'Leadership Opportunities', to: '/opportunities' },
  { label: 'Contact Us', to: '/contact' },
];

/** Legacy consultant URLs that redirect to Contact while the feature is off. */
export const consultantLegacyPaths: string[] = [
  'consultants',
  'consultants/*',
  'our-consultants',
  'our-consultants/*',
  'team',
  'team/*',
];
